import type { CogoKnowledgeRepository } from '@cogo/kg-repository'
import type { ChannelInput, ChannelOutput, DispatchTwoOpts } from '../_shared/channel-types'
import { dispatchChannelOne } from '../channel-1'
import { dispatchChannelTwo } from '../channel-2'

export interface RouteChannelOpts extends DispatchTwoOpts {}

export async function* routeChannel(
  input: ChannelInput,
  kg: CogoKnowledgeRepository,
  opts: RouteChannelOpts = {},
): AsyncIterable<ChannelOutput> {
  if (opts.signal?.aborted) {
    yield { kind: 'miss', reason: 'aborted' }
    return
  }

  const c1 = await dispatchChannelOne(input, kg, { signal: opts.signal, shapeSha: opts.shapeSha })

  if (c1.kind === 'rendered') {
    yield c1
    return
  }

  // Infrastructure failures + abort: don't fall through to Channel 2.
  if (
    c1.kind === 'miss' &&
    (c1.reason === 'aborted' || c1.reason === 'kg-init-failed' || c1.reason === 'wasm-unavailable')
  ) {
    yield c1
    return
  }

  // Otherwise (no-candidates, no-template, no-binding-schema, bind-throw, unsupported-mode): fall through.
  yield* dispatchChannelTwo(input, kg, opts)
}
